var $92fee9698e4d675a$exports = {};
$92fee9698e4d675a$exports = {
  "alpha": "Alpha",
  "black": "negro",
  "blue": "Azul",
  "blue purple": "p\xFArpura azulado",
  "brightness": "Brillo",
  "brown": "marr\xF3n",
  "brown yellow": "amarillo amarronado",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "cian",
  "cyan blue": "azul cian",
  "dark": "oscuro",
  "gray": "gris",
  "grayish": "gris\xE1ceo",
  "green": "Verde",
  "green cyan": "cian verdoso",
  "hue": "Tono",
  "light": "claro",
  "lightness": "Luminosidad",
  "magenta": "magenta",
  "magenta pink": "rosa magenta",
  "orange": "naranja",
  "orange yellow": "amarillo anaranjado",
  "pale": "p\xE1lido",
  "pink": "rosa",
  "pink red": "rojo rosado",
  "purple": "morado",
  "purple magenta": "magenta viol\xE1ceo",
  "red": "Rojo",
  "red orange": "naranja rojizo",
  "saturation": "Saturaci\xF3n",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " transparente");
  },
  "very dark": "muy oscuro",
  "very light": "muy claro",
  "vibrant": "intenso",
  "white": "blanco",
  "yellow": "amarillo",
  "yellow green": "verde amarillento"
};
export { $92fee9698e4d675a$exports as default };